import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/layout/Navigation';
import Footer from '../components/layout/Footer';
import { agentsData } from '../data/mock';
import '../styles/naabu.css';

const AgentsPage = () => {
  const [hoveredAgent, setHoveredAgent] = useState(null);

  return (
    <div style={{ background: '#000', minHeight: '100vh' }}>
      <Navigation />

      <main style={{ paddingTop: '80px' }}>
        {/* Header Section */}
        <section
          className="section-dark"
          style={{
            padding: '100px 5% 80px',
            position: 'relative',
          }}
        >
          <div className="grid-pattern" />

          {/* Particles */}
          <div className="particles">
            {[...Array(20)].map((_, i) => (
              <div
                key={i}
                className="particle"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 5}s`,
                }}
              />
            ))}
          </div>

          <div
            className="container"
            style={{
              position: 'relative',
              zIndex: 1,
              textAlign: 'center',
            }}
          >
            <h1
              style={{
                fontSize: 'clamp(40px, 5vw, 64px)',
                fontWeight: 800,
                marginBottom: '24px',
                letterSpacing: '-2px',
              }}
            >
              Your AI Team, <span style={{ color: '#f06a15' }}>On Demand</span>
            </h1>
            <p
              style={{
                fontSize: '20px',
                color: 'rgba(255, 255, 255, 0.7)',
                maxWidth: '600px',
                margin: '0 auto',
                lineHeight: 1.6,
              }}
            >
              Each agent is a specialist. Naabu decides when and how to use them.
            </p>
          </div>
        </section>

        {/* Agents Grid */}
        <section
          className="section-dark section-padding"
          style={{ paddingTop: '40px' }}
        >
          <div className="container" style={{ padding: '0 5%' }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
                gap: '24px',
              }}
            >
              {agentsData.map((agent) => (
                <div
                  key={agent.id}
                  className="glass-card"
                  onMouseEnter={() => setHoveredAgent(agent.id)}
                  onMouseLeave={() => setHoveredAgent(null)}
                  style={{
                    position: 'relative',
                    overflow: 'hidden',
                    cursor: 'default',
                    borderColor: hoveredAgent === agent.id ? agent.color : 'rgba(255, 255, 255, 0.1)',
                    transition: 'all 0.4s ease',
                  }}
                >
                  {/* Background Glow on Hover */}
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      width: '200px',
                      height: '200px',
                      background: `radial-gradient(circle, ${agent.color}20, transparent 70%)`,
                      opacity: hoveredAgent === agent.id ? 1 : 0,
                      transition: 'opacity 0.4s ease',
                      pointerEvents: 'none',
                    }}
                  />

                  <div style={{ position: 'relative', zIndex: 1 }}>
                    {/* Header */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        marginBottom: '16px',
                      }}
                    >
                      {/* Avatar */}
                      <div
                        style={{
                          width: '60px',
                          height: '60px',
                          background: `${agent.color}15`,
                          border: `1px solid ${agent.color}40`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '28px',
                          transition: 'all 0.3s ease',
                          transform: hoveredAgent === agent.id ? 'scale(1.1) rotate(5deg)' : 'scale(1)',
                        }}
                      >
                        {agent.emoji}
                      </div>

                      <div>
                        <h3
                          style={{
                            fontSize: '20px',
                            fontWeight: 700,
                            marginBottom: '4px',
                          }}
                        >
                          {agent.name}
                        </h3>
                        <span
                          style={{
                            fontSize: '13px',
                            fontWeight: 600,
                            color: agent.color,
                            textTransform: 'uppercase',
                            letterSpacing: '1px',
                          }}
                        >
                          {agent.role}
                        </span>
                      </div>
                    </div>

                    {/* Description */}
                    <p
                      style={{
                        fontSize: '15px',
                        color: 'rgba(255, 255, 255, 0.7)',
                        lineHeight: 1.6,
                      }}
                    >
                      {agent.description}
                    </p>
                  </div>

                  {/* Corner Accent */}
                  <div
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                      width: '60px',
                      height: '60px',
                      background: `linear-gradient(135deg, transparent 50%, ${agent.color}15 50%)`,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section
          className="section-dark"
          style={{
            padding: '100px 5%',
            textAlign: 'center',
          }}
        >
          <div className="container">
            <h2
              style={{
                fontSize: 'clamp(32px, 4vw, 48px)',
                fontWeight: 700,
                marginBottom: '24px',
              }}
            >
              Be the first to meet your AI team.
            </h2>
            <Link to="/coming-soon" className="btn-primary" style={{ fontSize: '18px', padding: '20px 40px', display: 'inline-flex' }}>
              <span>Pre-register now</span>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AgentsPage;
